var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmvco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 550 122",
    style: {
      enableBackground: "new 0 0 550 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0D3E5C;}\r\n\t.st1{fill:#9BC842;}\r\n\t.st2{fill:#9BC842;stroke:#9BC842;stroke-width:1.2705;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#0D3E5C;stroke-width:1.022;stroke-miterlimit:10;}\r\n\t.st4{fill:#8890A3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.4,88.7 162.7,88.7 162.7,30.7 221.2,30.7 221.2,39.4 172.3,39.4 172.3,54.2 206.3,54.2  206.3,62.9 172.3,62.9 172.3,80 223.4,80  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "313.5,88.7 303.9,88.7 303.9,41.3 303.7,41.3 273.6,88.4 243.7,41.3 243.5,41.3 243.5,88.7  233.9,88.7 233.9,30.7 245.9,30.7 273.7,73.2 301.5,30.7 313.5,30.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "393.1,30.7 361.9,88.7 350.8,88.7 319.6,30.7 330.3,30.7 356.3,79 382.3,30.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.8,43.9l-8.7,3.1c-5.9-6.2-14.1-9.4-24.6-9.4c-8,0-14.5,2.1-19.6,6.2c-5,4.1-7.6,9.3-7.6,15.7 c0,6.6,2.5,11.9,7.5,15.9c5,4,11.7,6,20.2,6c10.2,0,18.3-3.2,24.2-9.5l8.2,4.6c-4.2,4.9-8.9,8.4-14.1,10.5 c-5.3,2.2-11.5,3.2-18.8,3.2c-10.2,0-18.8-2.6-25.5-7.7c-7.7-5.9-11.6-13.6-11.6-23.1c0-9.3,3.9-17,11.8-22.9 c6.8-5.2,15.3-7.8,25.4-7.8C444,28.9,455.1,33.9,462.8,43.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.5,63.9c0,8.1-3.4,14.6-10.3,19.7c-5.9,4.3-13.2,6.5-22,6.5c-8.8,0-16.2-2.2-22.1-6.5 c-6.9-5-10.3-11.6-10.3-19.7c0-8,3.5-14.5,10.4-19.5c6.1-4.4,13.4-6.6,22-6.6c8.5,0,15.8,2.2,21.9,6.6 C530,49.5,533.5,56,533.5,63.9z M523.5,63.9c0-5.1-2.1-9.3-6.3-12.6c-4.2-3.3-9.5-4.9-16.1-4.9c-6.6,0-12,1.7-16.2,5 c-4.2,3.3-6.3,7.5-6.3,12.5c0,5.2,2.1,9.5,6.2,12.7c4.1,3.2,9.6,4.9,16.4,4.9c6.7,0,12.1-1.6,16.2-4.9 C521.4,73.4,523.5,69.1,523.5,63.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.5,16c-2.8-1.2-6.8-10.3-2.8-8.8c30.2,10.8,44.3,41.6,36.8,71c-7.8,30.2-42.7,48.3-71.8,36.4 c-9.3-3.8-17.4-9.8-23.7-17.1l1.7-0.8l3.8-0.4c4.1,4,9.3,7.3,15.3,9.5c23.4,8.4,51.4-0.4,63.2-23C140.2,57.4,131.6,27.1,104.5,16 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.8,79.3c-4.4-12.7-3.2-27.6,3.4-40.3c11.9-22.7,39.9-31.4,63.2-23c4.1,1.5,0.1-7.8-2.8-8.8 c-29.5-10.6-63.8,5-71.8,36.3c-3.2,12.4-2.1,24.9,2.3,36.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.2,12.6c17.1,2.3,28.1,19.5,33.1,34.5c7.5,22.5-0.1,45.9-15.7,63c-3.4,3.7,2.7,7.4,5.8,4.1 c17.7-19.4,24.6-44.5,17.1-69.9c-5.3-17.7-19.6-36-38.8-38.5C73.1,5.1,71.2,12,76.2,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.2,76.5c21.5,6.5,44.1,5.4,65.7-0.4c20.7-5.6,44.4-16.5,56.1-35.2c0.7-1.1-3.8-5.4-4.6-4.4 c-15.6,19.9-33.1,29.6-52.9,35.8C54.9,79,31.9,78.6,9.7,73.5C7.2,73,11.1,76.2,12.2,76.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.1,97.6C53.7,111.4,115.9,87,134.9,42.5c0.8-2-4.7-6.8-5.3-5.3C111,80.5,49.1,106.6,4.5,93.1 C0.8,92.1,6.5,97.2,8.1,97.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.4,36.1c0,0,3.9,6.6,5.3,16.2l4.9-3.6c0,0-3.1-14.9-8-13.9L127.4,36.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.3,61.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.3,61.1c0-31.5,22.6-57.1,54.1-57.1c31.5,0,57.1,25.6,57.1,57.1c0,31.5-25.6,56.1-57.1,56.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M533.8,83.8h-2.5v-1.3h6.6v1.3h-2.5v7.4h-1.6V83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M546.3,87.7c-0.1-1.1-0.1-2.5-0.1-3.7h0c-0.3,1.1-0.7,2.2-1,3.4l-1.3,3.8h-1.2l-1.2-3.7 c-0.3-1.1-0.6-2.3-0.9-3.4h0c0,1.1-0.1,2.5-0.2,3.7l-0.2,3.5h-1.5l0.6-8.8h2.1l1.1,3.5c0.3,1,0.6,2.1,0.8,3h0 c0.2-0.9,0.5-2,0.9-3.1l1.2-3.5h2.1l0.5,8.8h-1.6L546.3,87.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmvco);
export default __webpack_public_path__ + "static/media/emvco.3c1bf78678bc8bae2aa60f0ce0c41072.svg";
export { ForwardRef as ReactComponent };